/**
 * @file ScrollTop component
 * @author Willem Jan Weitering
 */
import { OnInit } from '@angular/core';
/**
 * Class for the ScrollTop component that provides scroll-to-top functionality.
 */
var ScrollTopComponent = /** @class */ (function () {
    /**
    * Constructs a ScrollTopComponent
    */
    function ScrollTopComponent() {
        /* Visibility variable used in template */
        this._isVisible = false;
    }
    /**
     * Scroll to top of page
     */
    ScrollTopComponent.prototype.scrollToTop = function () {
        /* cross-browser solution */
        document.body.scrollTop = document.documentElement.scrollTop = 1;
    };
    /**
    * Listen to window scroll event and set visibility variable
    */
    ScrollTopComponent.prototype.onScrollEvent = function () {
        this._isVisible = (window.pageYOffset > 5) ? true : false;
    };
    ScrollTopComponent.prototype.ngOnInit = function () {
    };
    return ScrollTopComponent;
}());
export { ScrollTopComponent };
